import { BriefcaseBusinessIcon as icon } from "lucide-react"
import create from "./contracts.create"
import edit from "./contracts.edit"
import list from "./contracts.list"
import show from "./contracts.show"
import { ContractRecord } from "./contracts.types"
const crud = (permissions: Record<string, string[]>) => ({
  name: "contracts",
  options: { label: "Contracts" },
  list:
    "contracts" in permissions && permissions.contracts.includes("list")
      ? list
      : undefined,
  show:
    "contracts" in permissions && permissions.contracts.includes("show")
      ? show
      : undefined,
  create:
    "contracts" in permissions && permissions.contracts.includes("create")
      ? create
      : undefined,
  edit:
    "contracts" in permissions && permissions.contracts.includes("edit")
      ? edit
      : undefined,
  icon,
  recordRepresentation: (record: ContractRecord): string =>
    `${record.username ?? ""} (${record.user_role ?? record.id})`,
})

export default crud
